package com.eladfinish.bible.contest.screens.main.usecases

import com.eladfinish.bible.contest.network.ApiResult
import com.eladfinish.bible.contest.screens.main.api.MainApi

class GetRemoteFileContentUseCase(
    private val mainApi: MainApi,
) {

    suspend operator fun invoke(): String {
        return when (val content = mainApi.getRemoteText()) {
            is ApiResult.ClientError -> content.throwable.toString()
            is ApiResult.Failure -> content.cause.toString()
            is ApiResult.Success -> content.data
        }
    }

}
